import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { path: "/", label: "首页", match: (p: string) => p === "/" },
  { path: "/category/news", label: "资讯", match: (p: string) => p.startsWith("/category/news") || p.startsWith("/detail/news") },
  { path: "/category/drama", label: "剧集", match: (p: string) => p.startsWith("/category/drama") || p.startsWith("/detail/drama") },
  { path: "/specials", label: "专题", match: (p: string) => p.startsWith("/specials") },
  { path: "/about", label: "关于", match: (p: string) => p.startsWith("/about") },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const submitSearch = (value: string) => {
    const q = value.trim();
    if (!q) return;
    setMenuOpen(false);
    setSearchOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer" aria-label="韩剧TV首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-tv-2-line text-xl"></i>
            </span>
            <span className="font-heading text-xl font-700 tracking-tight text-foreground-950">
              韩剧<span className="text-primary-500">TV</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const active = item.match(location.pathname);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`whitespace-nowrap cursor-pointer rounded-md px-4 py-2 text-sm font-500 transition-colors ${
                    active
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-2">
            <form
              className="hidden lg:flex items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-4 py-1.5"
              onSubmit={(e) => {
                e.preventDefault();
                submitSearch(keyword);
              }}
            >
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索剧集 / 资讯"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </form>
            <button
              type="button"
              onClick={() => setSearchOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 lg:hidden cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-full text-foreground-700 hover:bg-background-100 md:hidden cursor-pointer"
              aria-label="菜单"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <form
            className="flex items-center gap-2 border-t border-background-200/70 py-3 lg:hidden"
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch(keyword);
            }}
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索剧集 / 资讯"
              autoFocus
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button type="submit" className="whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-sm text-background-50 cursor-pointer">
              搜索
            </button>
          </form>
        )}
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navItems.map((item) => {
            const active = item.match(location.pathname);
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={`flex items-center justify-between rounded-lg px-4 py-3 text-base font-500 cursor-pointer ${
                  active ? "bg-primary-100 text-primary-700" : "text-foreground-800"
                }`}
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400"></i>
              </Link>
            );
          })}
        </nav>
      )}
    </header>
  );
}